export const FILE_JOB_BINDING_ADDED_EVENT = "file-job-binding-added";

export type FileJobBindingAddedDetail = {
  fileId: number;
  jobId: number;
  fileCreated?: boolean;
  projectId?: number;
  clientIds?: number[];
};

export function notifyFileJobBindingAdded(
  detail: FileJobBindingAddedDetail,
): void {
  window.dispatchEvent(
    new CustomEvent<FileJobBindingAddedDetail>(
      FILE_JOB_BINDING_ADDED_EVENT,
      { detail },
    ),
  );
}
